function RssFeedSVG() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.76539 13.4629C2.22095 13.4649 1.6893 13.6281 1.23751 13.9319C0.785728 14.2357 0.434057 14.6666 0.226874 15.1701C0.0196916 15.6735 -0.0337194 16.2271 0.0733804 16.7609C0.18048 17.2947 0.443292 17.7848 0.828654 18.1694C1.21402 18.554 1.70466 18.8159 2.23868 18.9219C2.7727 19.028 3.32616 18.9734 3.82923 18.7653C4.3323 18.5571 4.76244 18.2046 5.06537 17.7522C5.3683 17.2998 5.53045 16.7678 5.53136 16.2234C5.52906 15.491 5.23674 14.7894 4.71836 14.272C4.19998 13.7547 3.49777 13.4637 2.76539 13.4629Z"
        fill="#F47521"
      />
      <path
        d="M0 6.33301V10.286C2.375 10.286 4.65591 10.9889 6.33349 12.666C8.01106 14.3431 8.70849 16.6195 8.70849 18.9995H12.6665C12.6665 12.0773 6.92724 6.33301 0 6.33301Z"
        fill="#F47521"
      />
      <path
        d="M0 0V3.95346C8.46094 3.95346 15.0365 10.534 15.0365 19H19C19 8.52533 10.4897 0 0 0Z"
        fill="#F47521"
      />
    </svg>
  );
}

export { RssFeedSVG };
